import React, { useState, useEffect } from 'react';
import Tooltip from 'antd/es/tooltip';
import { Progress } from 'antd';
import { homeService, IprogressType } from './homeService';

export function HomeProgress() {

	const [dataSource, setDataSource] = useState<IprogressType[]>([]);
	const [totalNum, setTotalNum] = useState<number>(0);

	//列表查询
	const loadData = async () => {
		let { retData } = await homeService.progressStatistics();
		const { list, total } = retData;
		setDataSource(list);
		setTotalNum(total);
	}

	useEffect(() => {
		loadData();
	}, []);

	let color: {
		[prop: string]: string[];
	} = {
		"1": ["#33DDF8", "#1E6C95"],
		"2": ["#2473EF", "#173F8D"],
		"3": ["#33DDF8", "#1E6C95"],
		"4": ["#2473EF", "#173F8D"],
		"5": ["#A800FF", "#4C0E91"],
		"6": ["#33DDF8", "#1E6C95"],
		"7": ["#2473EF", "#4C0E91"],
		"8": ["#A800FF", "#4C0E91"],
		"9": ["#33DDF8", "#1E6C95"],
		"10": ["#2473EF", "#173F8D"],
		"11": ["#33DDF8", "#1E6C95"],
		"12": ["#2473EF", "#173F8D"],
		"13": ["#A800FF", "#4C0E91"],
		"14": ["#33DDF8", "#1E6C95"],
		"15": ["#2473EF", "#4C0E91"],
		"16": ["#A800FF", "#4C0E91"],
	}
	return (
		<div className="home-progress">
			<div className="home-but-wrapper mt-15 mb-30">
				<span>网站采集量分析</span>
			</div>
			{dataSource.map((item, index) => (
				<div className="home-progress-item" key={index}>
					<Tooltip title={item.num} arrowPointAtCenter getPopupContainer={() => document.getElementById("home-container") as HTMLElement} color={"#1D67FF"}>
						<span className="hover-tooltip" title={item.name}></span>
					</Tooltip>
					<span className="home-progress-item-title">{item.name}</span>
					<div className="home-progress-item-wrap">
						<Progress
							percent={item.num / totalNum * 100}
							strokeColor={color?.[`${index + 1}`]?.[0] ?? "#4C0E91"}
							trailColor={color?.[`${index + 1}`]?.[1] ?? "#1E6C95"}
							status="active"
							showInfo={false}
						/>
					</div>
				</div>
			))}
			{/* <div className="home-progress-item">
				<Tooltip title={"250"} arrowPointAtCenter getPopupContainer={() => document.getElementById("home-container") as HTMLElement} color={"#1D67FF"}>
					<span className="hover-tooltip"></span>
				</Tooltip>
				<span className="home-progress-item-title">中国电建</span>
				<Tooltip title={"250"} arrowPointAtCenter getPopupContainer={() => document.getElementById("home-container") as HTMLElement} color={"#1D67FF"}>
					<span className="hover-tooltip"></span>
				</Tooltip>
				<div className="home-progress-item-wrap">
					<Progress
						percent={60}
						strokeColor={"#A800FF"}
						trailColor={"#4C0E91"}
						status="active"
					/>
				</div>
			</div>
			<div className="home-progress-item">
				<Tooltip title={"250"} arrowPointAtCenter getPopupContainer={() => document.getElementById("home-container") as HTMLElement} color={"#1D67FF"}>
					<span className="hover-tooltip"></span>
				</Tooltip>
				<span className="home-progress-item-title">中国能建</span>
				<div className="home-progress-item-wrap">
					<Progress
						percent={60}
						strokeColor={"#33DDF8"}
						trailColor={"#1E6C95"}
						status="active"
					/>
				</div>
			</div>
			<div className="home-progress-item">
				<Tooltip title={"250"} arrowPointAtCenter getPopupContainer={() => document.getElementById("home-container") as HTMLElement} color={"#1D67FF"}>
					<span className="hover-tooltip"></span>
				</Tooltip>
				<span className="home-progress-item-title">中国交建</span>
				<div className="home-progress-item-wrap">
					<Progress
						percent={60}
						strokeColor={"#2473EF"}
						trailColor={"#173F8D"}
						status="active"
					/>
				</div>
			</div>
			<div className="home-progress-item">
				<Tooltip title={"250"} arrowPointAtCenter getPopupContainer={() => document.getElementById("home-container") as HTMLElement} color={"#1D67FF"}>
					<span className="hover-tooltip"></span>
				</Tooltip>
				<span className="home-progress-item-title">中国政府</span>
				<div className="home-progress-item-wrap">
					<Progress
						percent={60}
						strokeColor={"#33DDF8"}
						trailColor={"#1E6C95"}
						status="active"
					/>
				</div>
			</div>
			<div className="home-progress-item">
				<Tooltip title={"250"} arrowPointAtCenter getPopupContainer={() => document.getElementById("home-container") as HTMLElement} color={"#1D67FF"}>
					<span className="hover-tooltip"></span>
				</Tooltip>
				<span className="home-progress-item-title">应安网</span>
				<div className="home-progress-item-wrap">
					<Progress
						percent={60}
						strokeColor={"#2473EF"}
						trailColor={"#173F8D"}
						status="active"
					/>
				</div>
			</div>
			<div className="home-progress-item">
				<Tooltip title={"250"} arrowPointAtCenter getPopupContainer={() => document.getElementById("home-container") as HTMLElement} color={"#1D67FF"}>
					<span className="hover-tooltip"></span>
				</Tooltip>
				<span className="home-progress-item-title">京东</span>
				<Tooltip title={"250"} arrowPointAtCenter getPopupContainer={() => document.getElementById("home-container") as HTMLElement} color={"#1D67FF"}>
					<span className="hover-tooltip"></span>
				</Tooltip>
				<div className="home-progress-item-wrap">
					<Progress
						percent={60}
						strokeColor={"#A800FF"}
						trailColor={"#4C0E91"}
						status="active"
					/>
				</div>
			</div>
			<div className="home-progress-item">
				<Tooltip title={"250"} arrowPointAtCenter getPopupContainer={() => document.getElementById("home-container") as HTMLElement} color={"#1D67FF"}>
					<span className="hover-tooltip"></span>
				</Tooltip>
				<span className="home-progress-item-title">采购与招标</span>
				<div className="home-progress-item-wrap">
					<Progress
						percent={60}
						strokeColor={"#33DDF8"}
						trailColor={"#1E6C95"}
						status="active"
					/>
				</div>
			</div>
			<div className="home-progress-item">
				<Tooltip title={"250"} arrowPointAtCenter getPopupContainer={() => document.getElementById("home-container") as HTMLElement} color={"#1D67FF"}>
					<span className="hover-tooltip"></span>
				</Tooltip>
				<span className="home-progress-item-title">公共资源</span>
				<div className="home-progress-item-wrap">
					<Progress
						percent={60}
						strokeColor={"#2473EF"}
						trailColor={"#173F8D"}
						status="active"
					/>
				</div>
			</div> */}
		</div>
	);
}

